import { TCalendarAccount } from '../../utils/types'

export const resolveSelectedCalendarAccounts = (
    calendars: TCalendarAccount[] | undefined,
    selectedCalendars: TCalendarAccount[]
): TCalendarAccount[] => {
    if (!calendars) return selectedCalendars
    return calendars.map((account) => {
        const selectedAccount = selectedCalendars.find(
            (selected) =>
                selected.account_id === account.account_id &&
                selected.has_primary_calendar_scopes === account.has_primary_calendar_scopes &&
                selected.has_multical_scopes === account.has_multical_scopes
        )
        if (selectedAccount) return selectedAccount
        return {
            ...account,
            calendars: account.calendars.filter((calendar) => calendar.access_role === 'owner'),
        }
    })
}
